export class AnnouncementsLoad {
  public static readonly type = '[Announcements] Load';
}

export class AnnouncementsInitialState {
  public static readonly type = '[Announcements] Set Initial State';
}
